import React from 'react';
import {
    Box,
    FormControl,
    FormLabel,
    useColorModeValue,
    Input,
} from '@chakra-ui/react';

const FechaRangoPicker = ({ fechaInicio, fechaFin, onChange }) => {

    return (
        <Box className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4 p-2">
            <FormControl>
                <FormLabel className="!text-sm !text-navy-700 dark:!text-white !font-semibold tracking-wide mb-1">Fecha de Inicio</FormLabel>
                <Input
                    type="date"
                    value={fechaInicio}
                    onChange={(e) => onChange({ fechaInicio: e.target.value })}
                    max={fechaFin || undefined}
                    className="pr-10 w-full !rounded-xl border !bg-lightPrimary 
                    dark:!bg-navy-900 !text-sm !ring-none focus:!ring-brand-500 
                    focus:!border-brand-500 dark:focus:!ring-brand-400 dark:focus:!border-brand-400 
                    !outline-none !border-gray-200 dark:!border-white/10 !text-gray-800 dark:!text-gray-200"
                />
            </FormControl>

            <FormControl isDisabled={!fechaInicio}>
                <FormLabel className="!text-sm !text-navy-700 dark:!text-white !font-semibold tracking-wide mb-1">Fecha de Fin</FormLabel>
                <div className="relative">
                    <Input
                        type="date"
                        value={fechaFin}
                        onChange={(e) => onChange({ fechaFin: e.target.value })}
                        min={fechaInicio || undefined}
                        className="pr-10 w-full !rounded-xl border !bg-lightPrimary 
      dark:!bg-navy-900 !text-sm !ring-none focus:!ring-brand-500 
      focus:!border-brand-500 dark:focus:!ring-brand-400 dark:focus:!border-brand-400 
      !outline-none !border-gray-200 dark:!border-white/10 !text-gray-800 dark:!text-gray-200"
                    />
                </div>

            </FormControl>
        </Box>
    );
};

export default FechaRangoPicker;

